export default __webpack_public_path__ + "static/media/muurmontage.jpg";